module.exports = __webpack_public_path__ + "static/OpenSans-ExtraBold-49f89e34d03233b1f27788f75df7a40a.ttf";